import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'
import { Icon } from '@wartek-id/icon-v2'
import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text-v1'

type TDialogPelaksanaanAppealRollbackProps = {
  isOpen: boolean
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
}
export const DialogWarningPelaksanaanAppealRollback: React.FC<
  TDialogPelaksanaanAppealRollbackProps
> = ({ isOpen, isLoading, onClose, onConfirm }) => {
  const [agree, setAgree] = React.useState<boolean>(false)

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      autoFocus={false}
      returnFocus={false}
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <Icon fontSize="lg" color="critical">
            warning
          </Icon>

          <div className="space-y-1">
            <Text variant="heading-md">
              Perhatian! Seluruh isi dan nilai dokumen Praktik Kinerja Anda akan
              dihapus. Tetap lanjut ubah?
            </Text>
            <Text color="subdued" variant="body">
              Pastikan Anda sudah berdiskusi dengan atasan di luar sistem.
            </Text>
          </div>

          <Separator />

          <div className="pb-4">
            <Checkbox
              className="mt-2"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            >
              <Text variant="heading-sm">
                Saya mengerti bahwa isi seluruh dokumen akan dihapus dan saya
                harus mengulang pengisian dari awal
              </Text>
            </Checkbox>
          </div>

          <div className="flex justify-end space-x-5">
            <Button
              data-testid="appeal-rollback-back-button"
              disabled={isLoading}
              onClick={onClose}
              color="white"
              size="lg"
            >
              Kembali
            </Button>
            <Button
              onClick={onConfirm}
              className="space-x-1"
              color="blue"
              size="lg"
              disabled={!agree || isLoading}
              isLoading={isLoading}
            >
              <Icon color={agree ? 'inverse' : 'disabled'} fontSize="sm">
                lock_outline
              </Icon>
              <span>Ya, lanjut</span>
            </Button>
          </div>
        </div>
        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
